import { GetPerformList, GetStatusList, UpdateProcedureStatus, GetImageList, BeginExamination } from '@/api/screeing'

const screeing = {
  state: {
    PerformList: [],
    medicalStatus: [],
    UpdateProcedure: '',
    imgList: [],
    PerformListtotalCount: 0
  },
  mutations: {
    SET_PERFORMLIST: (state, datas) => {
      state.PerformList = datas
    },
    SET_MEDICALSTATUS: (state, datas) => {
      state.medicalStatus = datas
    },
    SET_UPDATEPROCADURE: (state, datas) => {
      state.UpdateProcedure = datas
    },
    SET_IMGLIST: (state, datas) => {
      state.imgList = datas
    },
    SET_PERFORM_LIST_TOTAL_COUNT: (state, datas) => {
      state.PerformListtotalCount = datas
    }
  },
  actions: {
    getPerformList({ commit }, data) { // 执行单列表
      return new Promise((resolve, reject) => {
        GetPerformList(data).then(response => {
          const data = response.data
          if (data.performList) {
            commit('SET_PERFORMLIST', data.performList)
            console.log(data.totalCount, '2222')
            commit('SET_PERFORM_LIST_TOTAL_COUNT', data.totalCount)
          } else {
            commit('SET_PERFORMLIST', [])
            commit('SET_PERFORM_LIST_TOTAL_COUNT', 0)
          }
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getStatusList({ commit }) { // 医疗状态
      return new Promise((resolve, reject) => {
        GetStatusList().then(response => {
          const data = response.data
          commit('SET_MEDICALSTATUS', data.examinStatus) // 医疗状态
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    updateProcedureStatus({ commit }, datas) { // 更新检查状态（用户）
      return new Promise((resolve, reject) => {
        UpdateProcedureStatus(datas).then(response => {
          const data = response.data
          commit('SET_UPDATEPROCADURE', data) // 医疗状态
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    beginExamination({ commit }, datas) { // 开始
      return new Promise((resolve, reject) => {
        BeginExamination(datas).then(response => {
          const data = response.data
          commit('SET_UPDATEPROCADURE', data) // 医疗状态
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    getImageList({ commit }, data) { // 影像列表
      return new Promise((resolve, reject) => {
        GetImageList(data).then(response => {
          const data = response.data
          commit('SET_IMGLIST', data.imageList) // 影像列表
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default screeing
